import { ALL_WEEK_DAYS, DayPart } from '../../pages/Campaigns/Form/Content/Blocks/Delivery/types';

export const DEFAULT_PART_LIST: DayPart[] = [
  {
    activeDayList: ALL_WEEK_DAYS,
    firstActiveHour: 0,
    lastActiveHour: 23,
  },
];
